import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { workspaceTagsQuery } from './project-tag.api';

/**
 * Workspace-scoped tag-name suggestions, shared across every surface that
 * lets a user pick or create tags (projects, folders, files, …). Wraps the
 * canonical `workspaceTagsQuery` so all callers draw from the same react-query
 * cache — a tag minted via one form becomes a suggestion in every other.
 *
 * Takes `workspaceId` as a parameter (rather than calling `useCurrentWorkspaceId`)
 * so this entity stays free of cross-entity value imports.
 * Callers typically pass `useCurrentWorkspaceId()`.
 */
export function useWorkspaceTagSuggestions(workspaceId: string | null | undefined): {
  suggestions: string[];
  isLoading: boolean;
} {
  const { data, isLoading } = useQuery(workspaceTagsQuery(workspaceId));

  const suggestions = useMemo(() => data?.items.map((tag) => tag.name) ?? [], [data]);

  return { suggestions, isLoading };
}
